import {
  Box,
  Button,
  Card,
  CardContent,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import { isEmpty } from "lodash";
import React, { useState } from "react";

const fieldFlex = { flex: "1 1 240px", minWidth: 0 };

export default function EditVendorForm(props) {
  const { vendor, handleClose, submitVendorEdit } = props;
  const [editVendorObj, setEditVendorObj] = useState({});

  const onVendorFieldChange = (e) => {
    setEditVendorObj({ ...editVendorObj, [e.target.name]: e.target.value });
  };

  const action = async () => {
    return submitVendorEdit(vendor, editVendorObj);
  };

  if (isEmpty(vendor)) {
    return <Typography>Loading…</Typography>;
  }

  return (
    <Card elevation={3}>
      <CardContent>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          <Typography variant="h6" component="h2">
            Vendor Info
          </Typography>

          <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
            <TextField
              label="Vendor Number"
              type="text"
              onChange={onVendorFieldChange}
              name="vendorNum"
              defaultValue={vendor.vendorNum}
              required
              variant="outlined"
              InputLabelProps={{ shrink: true }}
              sx={fieldFlex}
            />
            <TextField
              label="Vendor Name"
              type="text"
              onChange={onVendorFieldChange}
              name="name"
              defaultValue={vendor.name}
              required
              variant="outlined"
              InputLabelProps={{ shrink: true }}
              sx={fieldFlex}
            />
          </Box>

          <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
            <TextField
              label="Description"
              type="text"
              onChange={onVendorFieldChange}
              name="description"
              defaultValue={vendor.description}
              required
              variant="outlined"
              InputLabelProps={{ shrink: true }}
              sx={fieldFlex}
            />
            <TextField
              label="Service Territory"
              type="text"
              onChange={onVendorFieldChange}
              name="serviceTerritory"
              defaultValue={vendor.serviceTerritory}
              variant="outlined"
              InputLabelProps={{ shrink: true }}
              sx={fieldFlex}
            />
          </Box>

          <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
            <TextField
              label="Contact Name"
              type="text"
              onChange={onVendorFieldChange}
              name="contactName"
              defaultValue={vendor.contactName}
              variant="outlined"
              InputLabelProps={{ shrink: true }}
              sx={fieldFlex}
            />
            <TextField
              label="Contact Phone"
              type="text"
              onChange={onVendorFieldChange}
              name="contactPhone"
              defaultValue={vendor.contactPhone}
              variant="outlined"
              InputLabelProps={{ shrink: true }}
              sx={fieldFlex}
            />
            <TextField
              label="Contact Email"
              type="email"
              onChange={onVendorFieldChange}
              name="contactEmail"
              defaultValue={vendor.contactEmail}
              variant="outlined"
              InputLabelProps={{ shrink: true }}
              sx={fieldFlex}
            />
          </Box>

          <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
            <TextField
              label="SSO Rate Schedule"
              type="text"
              onChange={onVendorFieldChange}
              name="ssoRateSchedule"
              defaultValue={vendor.ssoRateSchedule}
              variant="outlined"
              InputLabelProps={{ shrink: true }}
              sx={fieldFlex}
            />
            <FormControl variant="outlined" sx={fieldFlex}>
              <InputLabel id="edit-vendor-status-label">Status</InputLabel>
              <Select
                labelId="edit-vendor-status-label"
                id="edit-vendor-status"
                label="Status"
                onChange={onVendorFieldChange}
                defaultValue={vendor.status || "Active"}
                name="status"
              >
                <MenuItem value="Active">Active</MenuItem>
                <MenuItem value="Inactive">Inactive</MenuItem>
              </Select>
            </FormControl>
          </Box>

          <Box sx={{ display: "flex", gap: 2, alignItems: "center", pt: 1 }}>
            <Button
              variant="contained"
              color="secondary"
              onClick={async () => {
                const success = await action();
                if (success) {
                  handleClose();
                }
              }}
            >
              Save
            </Button>
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
}
